import React from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Home = () => {
    return(
        <div id="page-home" style={{margin: 161}}>
            <h1>Home</h1>
            <Link to="/">
                <FiArrowLeft />
                Voltar para o login
            </Link>
            <Link to="/configuracoes">
                <FiArrowRight />
                Ir para config
            </Link>
        </div>
    )
};

export default Home;